import { handleActions } from 'redux-actions'

export const roomSearchResultsSelector = (state, resultsIndex) => {
  let searchResults = state.roomSearch.results
  return resultsIndex !== undefined ? searchResults[resultsIndex] : searchResults
}

export const searchResultsForListingSelector = (state, listingIndex) => {
  return roomSearchResultsSelector(state, listingIndex).rooms
}

export const roomSearchResultsReducer = handleActions(
  {
    FIND_ROOMS_SUCCESS: (state, action) => {
      return action.payload
    },
    CLEAR_ROOMS_SEARCH_RESULTS: () => {
      return []
    },

    RESET_SEARCH_PARAMS: () => [],

    FIND_LOCAL_ROOMS_RESULTS: (state) => {
      let searchDetails = localStorage.getItem('searchDetails')
      if (searchDetails && Object.keys(JSON.parse(searchDetails)).length > 0) {
        let searchDetailsObj = JSON.parse(searchDetails)
        return searchDetailsObj.searchResults
          ? Object.values(searchDetailsObj.searchResults)
          : []
      } else {
        return state
      }
    },

    SUBMIT_BOOK: (state, action) => {
      console.log('submit book reducer')
      return state
    }
  },
  []
)



// WEBPACK FOOTER //
// ./src/redux/modules/searchResultsModule.js